import logo from './logo.svg';
import './App.css';
import Navbar from './Components/navbar/Navbar';
import MyNavbar from './Components/navbar/Navbar';
import Header from './Components/header/Header';
import Project from './Components/project/Project';
import Ourservices from './Components/oruservices/Ourservics';
import OurClients from './Components/ourclients/Ourclient';
import Waywework from './Components/waywework/Waywework';
import Connect from './Components/connectsection/Connect';
import Footer from './Components/footer/Footer';
import Testimonials from './Components/Testimonial/Testimonial';
import Download from './Components/download/Downlaod';
import Popupboxx from './Components/popupboxx/Popupboxx';


function App() {
  return (
    <>
    <MyNavbar/>
    <Header/>
    <Project/>
    <Ourservices/>
 
    <OurClients/>
    <Download/>
    <Waywework/>
    <Connect/>
    <Testimonials/>
    <Popupboxx/>
    <Footer/>
    </>
  );
}

export default App;
